import RootStore from 'ynf-core-engine/RootStore'
import { ActionStore } from "ynf-core-engine";
import { when } from 'mobx'
import * as BaseExtendModule from './BaseExtend'
import referIndexDB from '../utils/cache';

import ReferStore from './referStore';
import { getJsonObj } from '../utils/tools';

const BaseExtend: any = BaseExtendModule;

class ReferRootStore extends RootStore {
  [x: string]: any
  constructor (props: any) {
    super(props)
    this.extendStoreField(props)
  }

  async init (meta: any) {
    await (() => {}) // 占位的让extendStoreField先执行
    this.parseDataSource(meta)
    /**
     * rootStore 解析优先级：
     * - 解析和挂载 context、pageStore、dataSource、utils、api、ErrorHandle 等基础公共能力
     * - 解析和挂载 Stores 实例【含默认生成和扩展】
     * - 解析和挂载 Actions 实例【含默认生成和扩展】
     * - 解析和挂载 Reactions 实例【含默认生成和扩展】
     */

    /**
     * 扩展脚本执行优先级：
     * - domain：领域扩展，及多个领域（通过二方包流水线发布扩展脚本，MF规范）
     * - industry：行业扩展，及多个行业（通过二方包流水线发布扩展脚本，MF规范）
     * - isv：ISV 生态扩展
     * - tenant：租户扩展、项目扩展（通过设计器编写和发布扩展脚本，AMD规范）
     */
    await this.parseStores(meta)
    await this.parseActions(meta)
    await this.initStoreData()
    this.referStore = new ReferStore(this)
    this.smartSearchStore = new BaseExtend.TableStore({}, this)
    await this.privateExtend() // 参照的扩展
    await this.runExtendScript() // 领域的扩展
    await this.extendTemplete(meta) // 模板的扩展
    await this.runDesignerExtend(meta)
    await this.parseFuncLibs(meta)
    await this.parseReactions(meta)
    await this.runReactionExtend()
    this.ready = true
    this.reactionError()
  }

  async initStoreData () {
    const { domainKey, serviceCode, billNo, refCode } = this.referInputProps
    const pageInfo = await referIndexDB.getCache(`pageinfo_${serviceCode}_${domainKey}_${billNo}_${refCode}`)
    pageInfo && this.pagingStore?.setPageInfo({ pageSize: pageInfo.value.pageSize || 10 }) // , pageIndex: pageInfo.value.pageIndex
  }

  async privateExtend () {
    const extendModul = require('./ReferExtend/extend')
    this.runExtend(extendModul)
  }

  async runExtend (extend: any = {}, type?: string) {
    const { billNo, domainKey } = this.pageStore.params || {};

    const { ExtendStore, ExtendAction, ExtendRootStore, ExtendReaction } = extend
    const extendType = type === 'DESIGNER' ? lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1BAEC6D805D0001B', '脚本') : lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1BAEC6D805D0001A', '扩展脚本')
    try {
      const extendedStores = await ExtendStore?.(this)
      for (const k in extendedStores) {
        this[k] = this[k] ? Object.assign(this[k], extendedStores[k]) : extendedStores[k]
      }
    } catch (error) {
      console.error(`${extendType} -> ExtendStore 执行出错`, error)
    }
    if (ExtendReaction) {
      this.pendingReactionExtendQueue.push([ExtendReaction, type])
    }
    try {
      const actionExtend = ExtendAction?.(this)
      const { actions = {} } = this
      // 1.设置扩展
      Object.entries(actions).forEach(([key, actionStore = {}]) => {
        actionStore?.mixin?.(
          (actionExtend?.default ?? actionExtend?.common),
          actionExtend?.[key]
        )
      })
      // 2.通过扩展新建实例
      if (actionExtend) {
        Object.keys(actionExtend).filter(key => !actions[key]).forEach((key = '') => {
          const options = actionExtend[key];
          this.actions[key] = new ActionStore(options, { name: key, libCode: `ynf-${domainKey}/${billNo}`, controlType: key, rootStore: this });
        })
      }
    } catch (error) {
      console.error(`${extendType} -> ExtendAction 执行出错`, error)
    }
    try {
      await ExtendRootStore?.(this)
    } catch (error) {
      console.error(`${extendType} -> ExtendRootStore 执行出错`, error)
    }
  }

  async parseStores (meta: any) {
    await this.batchParse(meta.children.find((child: any) => child?.controlType === 'Stores'), (storeMeta: any, StoreConstructor: any) => {
      const { alias, controlType } = storeMeta
      StoreConstructor = BaseExtend[controlType] ?? StoreConstructor
      this[alias] = new StoreConstructor(storeMeta, this)
    })
  }

  // rootstore上挂载一些变量 方便后续使用
  extendStoreField (props: any) {
    props.metaDataObj.refEntity.extendFieldJson = getJsonObj(props.metaDataObj.refEntity.extendField, {})
    this.referInputProps = props.referInputProps
    this.metaDataObj = props.metaDataObj

    // 参照唯一值---使用使用方的配置
    this.cEntityKeyFld = props.referInputProps.valueField || props.metaDataObj.refEntity.cEntityKeyFld
    this.refEntity = this.metaDataObj.refEntity
    // referRootStore.textField = referRootStore.topName ? metaDataObj.refEntity.cEntityNameFld : (typeof props.refReturn === 'object' ? props.refReturn[0] : props.refReturn); // 参照显示值 (有topName为树表, 树表时取meta中的显示字段)
    // this.textField = typeof this.referInputProps.refReturn === 'object' ? this.referInputProps.refReturn[0] : this.referInputProps.refReturn; // 参照显示值 (有topName为树表, 树表时取meta中的显示字段)

    // 这个treetable使用
    if (this.refEntity.cTpltype === 'TreeTable') {
      this.topName = this.metaDataObj.gridMeta?.viewmodel?.cBillName || this.metaDataObj.refEntity.name
    }
  }
}

const initRootStore = async (metaDataObj: any, props: any) => {
  if (!metaDataObj) return Promise.reject()
  const { diworkCode, domainKey, serviceCode, busiObj, diworkParams } = props.pageStore?.params || props
  const { name, cBillnum } = metaDataObj.refEntity
  const tplId = metaDataObj.gridMeta.nfwFeData.tplId

  return new Promise((resolve) => {
    // 创建模型
    const referRootStore = new ReferRootStore({
      meta: metaDataObj.gridMeta.nfwFeData,
      domainKey: props.domainKey,
      query: { ...props.pageStore?.query, ...props.query},
      history: { ...props.pageStore?.history },
      params: { diworkCode, domainKey, serviceCode, busiObj, diworkParams, billNo: cBillnum, billName: name, tplId },
      // params: { ...props.pageStore?.params },
      referInputProps: props,
      metaDataObj
    })

    when(() => referRootStore.ready, () => {
      // 后续可根据参照别名来命名
      window.referRootStore = referRootStore
      resolve(referRootStore)
    });
  })
}

export default initRootStore
